import React, { useState, useEffect } from "react";
import {
  CAvatar,
  CDropdown,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { cilBell } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { validate } from "../../Services/Login/LoginService";
import avatar8 from "./../../assets/images/user.png";
const AppHeaderDropdown = () => {
  const [formData, setFormdata] = useState([]);

  const validateUser = async () => {
    var validateResponse = await validate();
    if (validateResponse.success) {
      setFormdata(validateResponse);
    }
  };

  useEffect(() => {
    validateUser();
  }, []);

  return (
    <>
      <CDropdown variant="nav-item">
        <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
          <CAvatar src={avatar8} size="md" />
        </CDropdownToggle>
        <CDropdownMenu className="pt-0" placement="bottom-end">
          <CDropdownHeader className="bg-light fw-semibold py-2">
            {formData.data?.username?.toUpperCase()}
          </CDropdownHeader>
          <CDropdownItem href="/#/change-password">
            <CIcon icon={cilBell} className="me-2" />
            Change Password
            {/* <CBadge color="info" className="ms-2">
            42
          </CBadge> */}
          </CDropdownItem>
          <CDropdownItem
            onClick={() => {
              localStorage.removeItem("token");
            }}
            href="/#/login"
          >
            <CIcon icon={cilBell} className="me-2" />
            Logout
            {/* <CBadge color="info" className="ms-2">
            42
          </CBadge> */}
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>
    </>
  );
};

export default AppHeaderDropdown;
